import type { Application } from '@src/@types/app';
import { Experiments } from '@src/constants/abTest';
import { getHasUtmLabel } from '@src/reducers/route';
import { fullDealAndPing3Route } from '@src/shared/constants/pageRoutes';
import { isProverennyeZaymyPage } from '@src/utils/routing';

export const redirectToFullDealOffersPageExperiment = (ctx: Application.ReduxNextPageContext) => {
  const hasUtmLabel = getHasUtmLabel(ctx.store.getState());

  if (hasUtmLabel) {
    return false;
  }

  const experiments = ctx?.req?.__AB_TESTING__?.experiments;
  const isExperimentActive = experiments?.[Experiments.VITRIN_WITH_FULL_DEAL_OFFERS] === '1';
  const isProverennyeZaymy = isProverennyeZaymyPage(ctx.asPath);

  if (isProverennyeZaymy && isExperimentActive && ctx.res) {
    ctx.res.writeHead(302, { Location: fullDealAndPing3Route });
    ctx.res.end();

    return true;
  }

  return false;
};
